import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../components/Layout";

import { useAuth } from "../../../context/ContextApi";
import { CollaboratorDrawer } from "./components/CollaboratorDrawer";
import "./Collaborators.scss";
import addGrey from "../../../assets/img/add-gray.svg";
import EmptyContent from "../../../components/EmptyContent/EmptyContent";
import { EmptyCollaboratorsView } from "./components/EmptyCollaboratorsView";
import CollaboratorCard from "./components/CollaboratorCard";
import api from "../../../config/api";
import { useHistory } from "react-router-dom";

const emptyCollaboratorPostObject = {
  avatar: "",
  name: "",
  services: [],
};
function Collaborators() {
  const { userToken, userId, userEstablishment, userCategory, isPetEstablishment } = useAuth();
  const history = useHistory();

  const [isCollaboratorsLoading, setIsCollaboratorsLoading] = useState(true);
  const [collaborators, setCollaborators] = useState([]);
  const [collaboratorToSubmit, setCollaboratorToSubmit] = useState(emptyCollaboratorPostObject);

  const [isCollaboratorDrawerOpen, setIsCollaboratorDrawerOpen] = useState(false);
  // console.log("collaborators");
  // console.log(collaborators);
  const isCollaboratorsEmpty = useMemo(() => collaborators.length === 0, [collaborators]);
  const [collaboratorToAdd, setCollaboratorToAdd] = useState({});
  const handleAddCollaborator = () => {
    setIsCollaboratorDrawerOpen(true);
    setCollaboratorToSubmit(emptyCollaboratorPostObject);
  };
  const getCollaborators = async () => {
    try {
      const { data } = await api.get(`/professional/?establishment=${userEstablishment}`);

      setCollaborators(data);
    } catch (e) {
      console.error("CollaboratorDrawer getCollaborators error");
    } finally {
    }
  };
  useEffect(() => {
    getCollaborators();
  }, []);
  const handleEditCollaborator = (id) => {
    // TODO
  };
  const handleDeleteCollaborator = async (id) => {
    try {
      const response = await api.put(`professional-disable/${id}`).then((resp) => {
        console.log(resp);
        getCollaborators();
      });
    } catch (error) {
      console.log("handleDeleteCollaborator error", error.message);
    }
  };
  const handleSetEditCollaborator = (collaborator) => {
    history.push("/colaboradores/" + collaborator._id);
  };

  const handleServicesChange = (newServices) => {
    setCollaboratorToSubmit((collaboratorToSubmit) => ({ ...collaboratorToSubmit, services: newServices }));
  };

  const handleDaysOfWeekChange = (newDaysOfWeek) => {
    console.log(newDaysOfWeek);
  };

  useEffect(() => {}, [collaboratorToSubmit]);

  return (
    <>
      <Layout defaultMenu={7} title={"Colaboradores"} link={""}>
        <div className="store container-fluid px-lg-3 pt-1">
          {isCollaboratorsEmpty ? (
            <EmptyCollaboratorsView setIsCollaboratorDrawerOpen={setIsCollaboratorDrawerOpen} />
          ) : (
            <div className="row">
              <div className="col-12 col-lg-4 c-pointer" onClick={() => handleAddCollaborator()}>
                <div className="d-flex align-items-center add-collaborator-button bg-cl-lightgray text-cl-light-blue-steel fz-16 ff-roboto-medium">
                  <img alt="" src={addGrey} className=" add-collaborator-grey-icon me-3" />
                  Adicionar colaborador
                </div>
              </div>
              {collaborators.map((collaborator) => (
                <CollaboratorCard
                  collaborator={collaborator}
                  handleSetEditCollaborator={handleSetEditCollaborator}
                  handleDeleteCollaborator={handleDeleteCollaborator}
                />
              ))}
            </div>
          )}
        </div>
        <CollaboratorDrawer
          handleServicesChange={handleServicesChange}
          handleDaysOfWeekChange={handleDaysOfWeekChange}
          setCollaboratorToSubmit={setCollaboratorToSubmit}
          isOpen={isCollaboratorDrawerOpen}
          setIsCollaboratorDrawerOpen={setIsCollaboratorDrawerOpen}
          collaboratorToSubmit={collaboratorToSubmit}
        />
      </Layout>
    </>
  );
}

export default Collaborators;
